import { useEffect, useState } from "react";
import { FaRegUser, FaHeart, FaShoppingCart, FaBars, FaTimes } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import { PiSignInBold, PiSignOutBold } from "react-icons/pi";
import ConfirmLogoutModal from "../../modal/confirmLogoutModel";
import { fetchLoggedUser } from "../../redux/actions/loggedUserActions";
import { useDispatch, useSelector } from "react-redux";
import { BsEye } from "react-icons/bs";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate=useNavigate();
  const dispatch=useDispatch();
  const [isCancelModalOpen, setCancelModalOpen] = useState(false);
  const { user, error } = useSelector(
      (state) => state.loggedUserState
  );
  
  useEffect(() => {
    const fetchData = async () => {
      dispatch(fetchLoggedUser());  
    };
    fetchData();
  }, [dispatch]);

  {error && (
  <p className="text-red-600">
    {typeof error === "string" ? error : error.message || "Something went wrong"}
  </p>
  )}
  return (
    <nav className="bg-zinc-800 text-white px-3 md:px-4 xl:px-6 py-2 md:py-3 xl:py-4 flex items-center justify-between relative">
      
      <Link to="/">
      <div className="text-base md:text-lg xl:text-xl font-bold tracking-wide">
        <span className="text-white">ASIA</span>
        <span className="text-[#BDBDBD]"> LINK COMPUTERS</span>
      </div>
      </Link>
     
      <ul className="hidden md:flex gap-8 text-sm xl:text-lg font-medium">
        <li className="hover:text-[#A63F40] font-semibold hover:scale-110 cursor-pointer"
        onClick={()=>navigate("/")}>Home</li>
        <li className="hover:text-[#A63F40] font-semibold hover:scale-110 cursor-pointer"
        onClick={()=>navigate("/productpage")}>Products</li>
        <li className="hover:text-[#A63F40] font-semibold hover:scale-110 cursor-pointer"
        onClick={()=>navigate("/service")}>Services</li>
        <li className="hover:text-[#A63F40] font-semibold hover:scale-110 cursor-pointer"
        onClick={()=>navigate("/contactpage")}>Contact us</li>
      </ul>

    
      <div className="hidden md:flex gap-4 text-lg xl:text-xl">
        <FaHeart className="cursor-pointer hover:text-blue-500" onClick={()=>navigate("/wishlistpage")}/>
        <FaShoppingCart className="cursor-pointer hover:text-blue-500" onClick={()=>navigate("/cartpage")}/>
        <FaRegUser className="cursor-pointer hover:text-blue-500" onClick={()=>navigate("/profilepage")}/>
        {user && 
          (<PiSignOutBold className="cursor-pointer hover:text-blue-500" 
            onClick={() => setCancelModalOpen(true)}
            />
          )}
        {!user && 
          (<PiSignInBold className="cursor-pointer hover:text-blue-500" 
            onClick={() => navigate("/login")}
            />
          )}
      </div>

      
      <div className="md:hidden flex items-center">
        <button onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FaTimes size={18} /> : <FaBars size={18} />}
        </button>
      </div>

      
      {isOpen && (
        <div className="absolute top-full left-0 w-full bg-zinc-800 flex flex-col items-start px-6 py-4 gap-2 md:hidden z-50 text-sm">
          <li className="list-none hover:text-red-500 cursor-pointer"
          onClick={()=>{navigate("/");setIsOpen(false);}}>Home</li>
          <li className="list-none hover:text-red-500 cursor-pointer"
          onClick={()=>{navigate("/productpage");setIsOpen(false);}}>Products</li>
          <li className="list-none hover:text-red-500 cursor-pointer"
           onClick={()=>{navigate("/service");setIsOpen(false);}}>Services</li>
          <li className="list-none hover:text-red-500 cursor-pointer"
          onClick={()=>{navigate("/contactpage");setIsOpen(false);}}>Contact us</li>

          <div className="flex gap-4 mt-2 text-lg">
            <FaHeart className="cursor-pointer hover:text-blue-500" onClick={()=>navigate("/wishlistpage")}/>
            <FaShoppingCart className="cursor-pointer hover:text-blue-500" onClick={()=>navigate("/cartpage")}/>
            <FaRegUser className="cursor-pointer hover:text-blue-500" onClick={()=>navigate("/profilepage")}/>
            <PiSignOutBold className="cursor-pointer hover:text-blue-500" 
            onClick={() => setCancelModalOpen(true)}/>
          </div>
        </div>
      )}

      <ConfirmLogoutModal
            isOpen={isCancelModalOpen}
            onClose={() => setCancelModalOpen(false)}
      />
      
    </nav>
  );
}
